import React, { Fragment } from "react";
import styled from "styled-components";
import I10n from "../../features/i10n";
import Button from "../../atoms/button";
import { PRIMARY_COLOR } from "../../color-constants";
import MsxIcons from "../../features/msx-icons";
import ProductInformationCache from "../../persistence/description-cache";
import Toggle from "../toggle";
import Tooltip from "../documentation/tootip";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  overflow: auto;
  padding: 20px 20px 0px 20px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterActionRow = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0px 10px;
  margin-right: -10px;
`;

const ActionButtonWrapper = styled.div`
  margin-bottom: 10px;
  &:first-child {
    margin-right: 10px;
  }
`;

const LicenseGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const LicenseGroupTitle = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 20px;
`;

const LicenseItemTitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #626469;
  margin-bottom: 10px;
`;

const LicenseItemDescriptionLabel = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 10px;
`;

const LicenseItemQuantityLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #626469;
`;

const ClearPositioner = styled.div`
  display: flex;
  justify-content: center;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  margin-bottom: 10px;
`;

const ClearWrapper = styled.div`
  cursor: pointer;
  ${props => props.$disabled ? `
    opacity: 0.5;
    pointer-events: none;
  ` : ''}
`;

const ClearIconWrapper = styled.div`
  display: inline-block;
  margin-right: 5px;
  --se-icon-size: 20px;
`;

const QuantityAndDeleteWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const DeleteWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  justify-content: flex-end;
  align-items: center;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  cursor: pointer;

  ${props => props.$disabled ? 'opacity: 0.5; pointer-events: none;' : ''}
`;

const DeleteLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
`;

const OptimizeWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  padding: 5px 20px 10px 20px;
`;

const ToggleWrapper = styled.div`
  margin-top: 5px;
  margin-right: 10px;
`;

const OptimizeLabel = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #2F3136;
  margin-right: 8px;
`;

const OptimizeLabelAndHintContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

const TooltipText = styled.span`
  display: block;
  min-width: 200px;
  background-color: #fff;
  color: #000;
  text-align: center;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

class LicenseSelectorPackageSummaryContent extends React.Component {

  render() {

    const { optimizationHintLabel } = this.props;

    return (
      <>
        {this.props.canOptimize && <OptimizeWrapper id="optimizeWrapper">
          <ToggleWrapper>
            <Toggle
              active={this.props.optimizeLicenses}
              disabled={this.props.disabled}
              onToggle={() => {
                this.props.onOptimizeChange();
              }}
            />
          </ToggleWrapper>

          <OptimizeLabelAndHintContainer>
            <OptimizeLabel>{I10n.get('screen.licence_selector.optimize_package')}</OptimizeLabel>
            {optimizationHintLabel && false && (
               <Tooltip
                data-clickable
                toggleElement={
                  <qds-icon name={'information-circle'} size="large"></qds-icon>
                }
                containerElement={
                  <TooltipText>
                    {optimizationHintLabel}
                  </TooltipText>
                }
                allowTop={true}
              ></Tooltip>
            )}
          </OptimizeLabelAndHintContainer>
        </OptimizeWrapper>}
        {this.props.isOpen && this.props.licenseGroups.length > 0 && <>
          <Content>
            {this.props.licenseGroups.map((licenseGroup, idx) => {
              return (<LicenseGroup key={idx}>
                <LicenseGroupTitle>{licenseGroup.name}</LicenseGroupTitle>
                {licenseGroup.licences.sort((a,b) => a.order - b.order).map((license, idx) => {
                  return (<Fragment key={idx}>
                    <LicenseItemTitle>{license.id}</LicenseItemTitle>
                    <LicenseItemDescriptionLabel>{ProductInformationCache.getDescription(license.id) || license.description}</LicenseItemDescriptionLabel>
                     <QuantityAndDeleteWrapper>
                      <LicenseItemQuantityLabel>{`${license.quantityLabel != null ? license.quantityLabel : I10n.get('bom.qty')} ${license.quantity || 0}`}</LicenseItemQuantityLabel>
                      {this.props.removeSoftwareLicence && license.canRemove && <DeleteWrapper $disabled={this.props.disabled} onClick={() => {
                        this.props.removeSoftwareLicence(license);
                       }}>
                        <MsxIcons name="delete"></MsxIcons>
                        <DeleteLabel>{I10n.get('menu_delete')}</DeleteLabel>
                      </DeleteWrapper>}
                    </QuantityAndDeleteWrapper>
                  </Fragment>);
                })}
              </LicenseGroup>);
            })}
          </Content>
          <Footer>
            <FooterActionRow>
              {(this.props.actionButtons || []).map((button, idx) => {
                return (
                  <ActionButtonWrapper key={idx}>
                    <Button disabled={this.props.disabled} importance={button.importance} icon-name={button.icon} onClick={() => {
                      button.action();
                    }}>{button.label}</Button>
                  </ActionButtonWrapper>
                );
              })}
            </FooterActionRow>
            {this.props.onClear && <ClearPositioner>
              <ClearWrapper $disabled={this.props.disabled} onClick={() => {
                this.props.onClear();
              }}>
                <ClearIconWrapper>
                  <MsxIcons name="replace" size="small"></MsxIcons>
                </ClearIconWrapper>
                {I10n.get('screen.licence_selector.clear_restart')}
              </ClearWrapper>
            </ClearPositioner>}
          </Footer>
        </>}
      </>
    );
  }
}

export default LicenseSelectorPackageSummaryContent;
